import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { routingTransition } from '@app/shared/animations/routing-transitions';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader-standard.component.html',
  styleUrls: ['./uploader-standard.component.scss'],
  animations: [
    routingTransition,
  ]
})
export class UploaderStandardComponent {

  constructor() { }

  prepareRoute(outlet: RouterOutlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

}
